import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useParams } from 'react-router-dom';

const EmbedViewHtml = () => {
  const { username } = useParams();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Create container div
    const container = document.createElement('div');
    container.id = 'searchBubble-container';
    container.style.width = '100%';
    container.style.minHeight = '100px';
    // Create iframe
    const iframe = document.createElement('iframe');
    iframe.id = 'searchBubbleIframe';
    iframe.src = `https://www.searchbubble.com/embed/${username}`;
    iframe.style.width = '100%';
    iframe.style.border = 'none';
    iframe.style.margin = '0';
    iframe.style.padding = '0';
    iframe.scrolling = 'no';
    iframe.setAttribute('allowTransparency', 'true');
    iframe.title = 'SearchBubble Embed';

    // Add iframe to container
    container.appendChild(iframe);

    // Add container to the content div
    const contentDiv = containerRef.current.querySelector('.content');
    if (contentDiv) {
      contentDiv.appendChild(container);
    }

    // Load and initialize iframe-resizer
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.3.6/iframeResizer.min.js';
    script.onload = function () {
      // @ts-ignore
      if (window.iFrameResize) {
        // @ts-ignore
        window.iFrameResize({
          log: false,
          checkOrigin: false,
          heightCalculationMethod: 'taggedElement',
          scrolling: 'omit',
          warningTimeout: 0
        }, iframe);
      }
    };
    document.body.appendChild(script);

    // Cleanup function
    return () => {
      if (contentDiv && container) {
        contentDiv.removeChild(container);
      }
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="embed-view-html" ref={containerRef}>
      <style>
        {`
          html, body {
            margin: 0;
            padding: 0;
            height: 100%;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            color: #2c3e50;
            background: #f5f6f7;
          }
          .embed-view-html {
            margin: 0;
            min-height: 100vh;
            display: flex;
            flex-direction: column;
            background: #f5f6f7;
          }
          .header {
            background: #404040;
            padding: 1.75rem 1.5rem 1.25rem 1.5rem;
            text-align: center;
            border-bottom: none;
            border-radius: 0 0 12px 12px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.06);
          }
          .header h1 {
            color: #fff;
            font-size: 2rem;
            font-weight: 600;
            margin: 0 0 0.5rem 0;
            letter-spacing: -0.5px;
          }
          .header p {
            color: #e0e0e0;
            font-size: 1rem;
            margin: 0;
            line-height: 1.5;
          }
          .content {
            flex: 1 0 auto;
            margin: 40px 0;
            min-height: 100px;
            background: #f5f6f7;
          }
          .footer {
            background: #404040;
            padding: 1.25rem 1.5rem 1.75rem 1.5rem;
            text-align: center;
            margin-top: auto;
            width: 100%;
            border-top: none;
            border-radius: 12px 12px 0 0;
            box-shadow: 0 -2px 8px rgba(0,0,0,0.06);
          }
          .footer h2 {
            color: #fff;
            font-size: 1.3rem;
            font-weight: 500;
            margin: 0 0 0.5rem 0;
          }
          .footer p {
            color: #e0e0e0;
            font-size: 0.95rem;
            margin: 0;
            line-height: 1.5;
          }
          #searchBubble-container {
            width: 100%;
            min-height: 100px;
          }
          #searchBubbleIframe {
            width: 100%;
            border: none;
            margin: 0;
            padding: 0;
          }
        `}
      </style>

      <div className="header">
        <h1>Welcome to {username}&apos;s Embedded Page</h1>
        <p>Experience the embedded Search Bubble for <b>{username}</b></p>
      </div>
      <div className="content">
        {/* SearchBubble Embed will be dynamically inserted here */}
      </div>
      <div className="footer">
        <h2>Thanks for visiting {username}&apos;s page!</h2>
        <p>This area is powered by Search Bubble's embed feature.</p>
      </div>
    </div>
  );
};

export default EmbedViewHtml;